import LocationModel from '@/models/Location'

const getters = {
  getLocationsById: state => groupId => {
    const locations = state.locationGroupMap.get(groupId)
    return locations
      .map(location => {
        if (location.id) {
          return {
            id: location.id,
            locationGroupId: groupId,
            name: location.name,
            shapeType: location.shapeType,
            shape: {
              latitude: location.shape.coordinates[1],
              longitude: location.shape.coordinates[0],
            },
            status: location.status,
          }
        } else {
          // poi検索から取得した地点
          return {
            id: null,
            locationGroupId: groupId,
            name: 'poi_location',
            shapeType: location.shapeType,
            shape: location.shape,
            status: 'active',
          }
        }
      })
      .map(LocationModel.assign)
  },
  getLocationListCount: function(state) {
    return state.locationListCount
  },
}

export default getters
